<template>
  <layout :background="background" :errors="errors" :nav-items="aspectMenuItems" :toasts="toasts">
    <div class="row">
      <div :class="'col-' + (logEntries ? '8' : '12') + ' pe-2'">
        <slot />
      </div>
      <div v-if="logEntries" class="col-4 ps-2 pe-4">
        <app-event-log :log-entries="logEntries" :meta="meta" :resource-type="resourceType"></app-event-log>
      </div>
    </div>
  </layout>
</template>

<script>
import AppEventLog from '@/structures/default/components/AppEventLog/AppEventLog';
import Layout from '@/structures/moviary/Pages/Layout';

export default {
  components: {
    AppEventLog,
    Layout,
  },
  props: {
    aspectMenuItems: { type: Object, default: () => {} },
    background: { type: String, default: () => '' },
    resourceType: { type: String, default: '' },
    meta: { type: Object, default: () => {} },
    logEntries: { type: Object, default: () => {} },
    toasts: { type: Object, default: () => {} },
    errors: { type: Object, default: () => {} },
    title: { type: String, default: '' },
  },
  setup() {
    return {};
  },
};
</script>
